import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

export const Layout = ({ className, children, rows = 1 }) => {
  return (
    <div className={twMerge(`grid`, `grid-rows-${rows}`, className)}>
      {children}
    </div>
  );
};

Layout.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};
